export const idlFactory = ({ IDL }) => {
  const Result = IDL.Variant({ 'ok' : IDL.Bool, 'err' : IDL.Text });
  const UserRole = IDL.Variant({
    'admin' : IDL.Null,
    'operator' : IDL.Null,
    'viewer' : IDL.Null,
  });
  const UserProfile = IDL.Record({
    'id' : IDL.Text,
    'username' : IDL.Text,
    'createdAt' : IDL.Int,
    'role' : UserRole,
    'isActive' : IDL.Bool,
    'email' : IDL.Text,
    'lastLogin' : IDL.Opt(IDL.Int),
  });
  const UserExport = IDL.Record({
    'id' : IDL.Text,
    'username' : IDL.Text,
    'email' : IDL.Text,
    'passwordHash' : IDL.Text,
    'salt' : IDL.Opt(IDL.Text),
    'role' : UserRole,
    'createdAt' : IDL.Int,
    'lastLogin' : IDL.Opt(IDL.Int),
    'isActive' : IDL.Bool,
  });
  const UserUpdateRequest = IDL.Record({
    'email' : IDL.Opt(IDL.Text),
    'role' : IDL.Opt(UserRole),
    'isActive' : IDL.Opt(IDL.Bool),
  });
  const Result_1 = IDL.Variant({
    'ok' : IDL.Record({ 'imported' : IDL.Nat, 'skipped' : IDL.Nat }),
    'err' : IDL.Text,
  });
  const Result_2 = IDL.Variant({
    'ok' : IDL.Vec(UserProfile),
    'err' : IDL.Text,
  });
  const Result_3 = IDL.Variant({
    'ok' : IDL.Vec(UserExport),
    'err' : IDL.Text,
  });
  const ValidationResult = IDL.Variant({
    'ok' : UserProfile,
    'err' : IDL.Text,
  });
  const LoginRequest = IDL.Record({
    'username' : IDL.Text,
    'password' : IDL.Text,
  });
  const Session = IDL.Record({
    'token' : IDL.Text,
    'expiresAt' : IDL.Int,
    'userId' : IDL.Text,
    'createdAt' : IDL.Int,
    'isActive' : IDL.Bool,
  });
  const AuthResult = IDL.Variant({ 'ok' : Session, 'err' : IDL.Text });
  const RegisterRequest = IDL.Record({
    'username' : IDL.Text,
    'password' : IDL.Text,
    'role' : UserRole,
    'email' : IDL.Text,
  });
  const UserResult = IDL.Variant({ 'ok' : UserProfile, 'err' : IDL.Text });
  return IDL.Service({
    'adminResetPassword' : IDL.Func([IDL.Text, IDL.Text, IDL.Text], [Result], []),
    'createUser' : IDL.Func([IDL.Text, RegisterRequest], [UserResult], []),
    'deactivateUser' : IDL.Func([IDL.Text, IDL.Text], [Result], []),
    'deleteUser' : IDL.Func([IDL.Text, IDL.Text], [Result], []),
    'exportUsers' : IDL.Func([IDL.Text], [Result_3], []),
    'getAllUsers' : IDL.Func([IDL.Text], [Result_2], []),
    'getUserProfile' : IDL.Func([IDL.Text], [ValidationResult], []),
    'health' : IDL.Func([], [IDL.Text], ['query']),
    'importUsers' : IDL.Func([IDL.Text, IDL.Vec(UserExport)], [Result_1], []),
    'isFirstRun' : IDL.Func([], [IDL.Bool], ['query']),
    'login' : IDL.Func([LoginRequest], [AuthResult], []),
    'logout' : IDL.Func([IDL.Text], [Result], []),
    'reactivateUser' : IDL.Func([IDL.Text, IDL.Text], [Result], []),
    'register' : IDL.Func([RegisterRequest], [UserResult], []),
    'setupInitialAdmin' : IDL.Func([RegisterRequest], [UserResult], []),
    'updatePassword' : IDL.Func([IDL.Text, IDL.Text, IDL.Text], [Result], []),
    'updateUser' : IDL.Func([IDL.Text, IDL.Text, UserUpdateRequest], [UserResult], []),
    'validateSession' : IDL.Func([IDL.Text], [ValidationResult], []),
  });
};
export const init = ({ IDL }) => { return []; };
